.note {
  display: block;
  margin-top: 4px;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
  max-width: 92ch;
}

.list {
  margin: 2px 0;
  padding-left: 18px;
}
